import { LitElement, html, css, utils } from '@hh/global.js'

class HHNavDropdown extends LitElement {
  static properties = {
    _tier1: {},
    _tier2: {},
    linkItems: {},
    buttonItems: {},
    contentItems: {},
    linkT2Items: {},
    contentT2Items: {},
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    this.linkItems = utils.all(`.js-t1-link`, this) || []
    this.buttonItems = utils.all(`.js-t1-button`, this)
    this.contentItems = utils.all(`.js-t1-content`, this) || []
    this.linkT2Items = utils.all(`.js-t2-link`, this) || []
    this.contentT2Items = utils.all(`.js-t2-content`, this) || []
    this._tier1 = '0'
    this._tier2 = '0'

    const headerLinkItems = document.querySelectorAll(
      '.nav-desktop__link-header'
    )
    this.headerLinkItems = headerLinkItems
    this.dropdowns = document.querySelectorAll('.nav-desktop__dropdown')

    this.addHoverListeners()
    this.addFocusListeners()
    this.updateActiveContent()
    this.updateActiveFeatured()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  requestUpdate(name, oldValue) {
    if (name === '_tier1') {
      this._tier2 = '0'
      this.updateActiveContent()
      this.updateActiveFeatured()
    }

    if (name === '_tier2') {
      this.updateActiveFeatured()
    }

    return super.requestUpdate(name, oldValue)
  }

  addFocusListeners() {
    this.buttonItems.forEach((buttonItem, index) => {
      buttonItem.addEventListener('focusin', (event) => {
        event.target.classList.remove('visually-hidden')
      })
    })

    this.buttonItems.forEach((buttonItem, index) => {
      buttonItem.addEventListener('focusout', (event) => {
        event.target.classList.add('visually-hidden')
      })
    })
  }

  addHoverListeners() {
    this.linkItems.forEach((linkItem, index) => {
      linkItem.addEventListener('mouseover', () => {
        const tier1 = linkItem.getAttribute('data-t1-item-no')
        if (this._tier1 !== tier1) {
          this._tier1 = tier1
        }
      })
    })

    this.headerLinkItems.forEach((headerLinkItem) => {
      headerLinkItem.addEventListener('focusin', () => {
        this.dropdowns.forEach((dropdown) => {
          dropdown.classList.remove('dropdown-active')
        })
      })
    })

    this.buttonItems.forEach((buttonItem, index) => {
      buttonItem.addEventListener('keypress', (event) => {
        if (event.key == 'Enter' || event.key == ' ') {
          const tier1 = buttonItem.getAttribute('data-t1-item-no')
          if (this._tier1 !== tier1) {
            this._tier1 = tier1
          }
        }
      })
    })

    this.linkT2Items.forEach((linkItem, index) => {
      linkItem.addEventListener('mouseover', () => {
        const tier2 = linkItem.getAttribute('data-t2-item-no')
        if (this._tier2 !== tier2) {
          this._tier2 = tier2
        }
      })
    })

    this.linkT2Items.forEach((linkItem, index) => {
      linkItem.addEventListener('focusin', () => {
        const tier2 = linkItem.getAttribute('data-t2-item-no')
        if (this._tier2 !== tier2) {
          this._tier2 = tier2
        }
      })
    })
  }

  updateActiveContent() {
    if (this.linkItems.length > 0) {
      this.linkItems.forEach((item) => item.classList.remove('is-active'))
      const linkItem = this.linkItems.find(
        (item) => item.getAttribute('data-t1-item-no') === this._tier1
      )
      linkItem && linkItem.classList.add('is-active')
    }

    if (this.buttonItems.length > 0) {
      this.buttonItems.forEach((item) => item.classList.remove('is-active'))
      const buttonItem = this.buttonItems.find(
        (item) => item.getAttribute('data-t1-item-no') === this._tier1
      )
      buttonItem && buttonItem.classList.add('is-active')
    }

    if (this.contentItems.length > 0) {
      this.contentItems.forEach((item) => item.classList.remove('is-open'))
      const contentItem = this.contentItems.find(
        (item) => item.getAttribute('data-t1-content-no') === this._tier1
      )

      contentItem && contentItem.classList.add('is-open')
    }
  }

  updateActiveFeatured() {
    if (this.linkT2Items.length > 0) {
      this.linkT2Items.forEach((item) => item.classList.remove('is-active'))
      const linkItem = this.linkT2Items.find(
        (item) =>
          item.getAttribute('data-t2-item-no') === this._tier2 &&
          item.getAttribute('data-t1-content-no') === this._tier1
      )
      linkItem && linkItem.classList.add('is-active')

      this.linkT2Items.forEach((item) =>
        item.addEventListener('focusin', () => {
          item.classList.add('is-active')
        })
      )
      this.linkT2Items.forEach((item) =>
        item.addEventListener('focusout', () => {
          item.classList.remove('is-active')
        })
      )
    }

    if (this.contentT2Items.length > 0) {
      this.contentT2Items.forEach((item) => item.classList.remove('is-open'))
      const contentItem = this.contentT2Items.find(
        (item) =>
          item.getAttribute('data-t2-content-no') === this._tier2 &&
          item.getAttribute('data-t1-content-no') === this._tier1
      )
      contentItem && contentItem.classList.add('is-open')
    }
  }

  showOverlay() {
    document
      .querySelector('.js-desktop-nav-overlay')
      .classList.add('is-visible')
  }

  hideOverlay() {
    document
      .querySelector('.js-desktop-nav-overlay')
      .classList.remove('is-visible')
  }

  render() {
    return html`<div role="dialog" aria-label="desktop navigation dropdown" aria-modal="true" tabindex="-1">
      <div class="content" tabindex="0">
        <hh-focus-trap active="${this.open}">
          <slot></slot>
        </hh-focus-trap>
      </div>
    </div>`
  }

  static styles = css`
    :host {
    }
  `
}

customElements.define('hh-navigation-dropdown', HHNavDropdown)

class HHAccessibilityButtonWrapper extends HTMLElement {
  constructor() {
    super()

    this.dropdowns = document.querySelectorAll('.nav-desktop__dropdown')
    this.button = this.querySelector('button')
    this.dropdown = this.parentElement.querySelector('.nav-desktop__dropdown')

    this.button.addEventListener('keypress', this.handleKeypress.bind(this))
    this.button.addEventListener('focusin', this.handleFocus.bind(this))
    this.button.addEventListener('focusout', this.handleFocus.bind(this))
  }

  handleFocus(event) {
    if (event.type == 'focusout') {
      event.target.classList.add('visually-hidden')
    } else {
      event.target.classList.remove('visually-hidden')
    }
  }

  handleKeypress(event) {
    if (event.key == 'Enter' || event.key == ' ') {
      this.dropdowns.forEach((dropdown) =>
        dropdown != this.dropdown
          ? dropdown.classList.remove('dropdown-active')
          : null
      )
      if (this.dropdown.classList.contains('dropdown-active')) {
        this.dropdown.classList.remove('dropdown-active')
      } else {
        this.dropdown.classList.add('dropdown-active')
      }
    }
  }
}

customElements.define(
  'hh-accessbility-button-wrapper',
  HHAccessibilityButtonWrapper
)
